import axios, { AxiosResponse } from "axios";
import { SubledgerEndpoints } from "../SubledgerEndpoints";
import { config } from "../config";
import { AuthorizationToken, authGetBlob } from "./RequestHelpers";
import { IUserProviderState } from "../contexts/UserContext";

export interface IPostAttachmentResponse {
  readonly SelectedSlEntryIds?: number[];
  readonly blobName: string;
  readonly inputFileName: string;
  readonly fileStorageUri: string;
  readonly fileSize: number;
  readonly uploadedOn: string;
}

export async function getAttachmentFileDownload(
  blobName: string,
  fileName: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<File> {
  const getAttachmentDownloadUrl =
    config.get("attachmentUrl") + SubledgerEndpoints.attachmentDownloadPath + "/" + blobName;

  const result = (await authGetBlob(getAttachmentDownloadUrl, getTokenFn)) as unknown as File;
  return result;
}

export async function postAttachment(
  file: File,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<IPostAttachmentResponse> {
  const postAttachmentUrl = config.get("attachmentUrl") + SubledgerEndpoints.attachmentPath;
  const formData = new FormData();
  formData.append("files[]", file);
  const Authorization = await AuthorizationToken(getTokenFn);
  const result = await axios.post(postAttachmentUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization
    }
  });
  if (result.data) {
    return result.data as IPostAttachmentResponse;
  } else {
    throw new Error("No data in payload");
  }
}

export async function deleteAttachment(
  attachmentBlobNameToDelete: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<AxiosResponse<any>> {
  const deleteAttachmentUrl =
    config.get("attachmentUrl") + SubledgerEndpoints.attachmentPath + attachmentBlobNameToDelete;
  const Authorization = await AuthorizationToken(getTokenFn);
  const result = await axios({
    method: "delete",
    url: deleteAttachmentUrl,
    data: {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization
      },
      attachmentBlobNameToDelete
    }
  });
  return result;
}
